//src/clientesApi.ts
import { getAuthToken } from '../security/AuthLogin';

const BASE_URL = `${window.location.protocol}//${window.location.hostname}`;
const API_URL = `${BASE_URL}/api`;

export interface Cliente {
  id: number;                            // NO SE MUESTRA NI EDITA
  id_usuario: string;                    // SALE, NO EDITA

  nombre: string | null;                 // SALE, NO EDITA
  apellido1: string | null;              // NO SALE
  apellido2: string | null;              // NO SALE
  email: string | null;                  // SALE, NO EDITA

  telefono: string | null;               // SI
  empresa: string | null;                // SI
  cif: string | null;                    // SI
  direccion: string | null;              // SI
  actividad: string | null;              // SI
  cp: string | null;                     // SI
  poblacion: string | null;              // SI
  cuenta: string | null;                 // SI
  iban: string | null;                   // SI
  cods_clasificaciones: string | null;   // SI
  cods_cpv: string | null;               // SI
  cods_cpv_ignorar: string | null;       // SI
  lugares: string | null;                // SI
  paises: string | null;                 // SI
  importe_min: string | null;            // SI (numeric, lo tratamos como string)
  importe_max: string | null;            // SI (numeric)
  f_alta: string | null;                 // SALE, NO EDITA
  f_baja: string | null;                 // SI (date)
  normas_iso: string | null;             // Ya existe (campo general)
  clasificaciones_reconocidas: string | null; // SI

  // NUEVOS CAMPOS FAVORITOS
  fecha_constitucion: string | null;
  habilitacion_profesional: string | null;
  cifra_anual_negocio: string | null;
  certificados_cbe: string | null;
  plan_igualdad: string | null;
  numero_empleados: string | null;
  otros_contactos: string | null;

  comercial: string | null;              // NO SALE
  obs: string | null;                    // SI (se utiliza en lugar de "otras_observaciones")
  notificaciones: boolean | null;        // NO SALE
  emails_notificaciones: string | null;  // NO SALE
  activo: boolean | null;                // NO SALE
  id_tipo_contrato: number | null;       // NO SALE
  favoritos: string | null;              // ORIGINAL (puedes eliminarlo si ya no se usa)
  leidos: string | null;                 // NO SALE
  enviado_hoy: number | null;            // NO SALE

  // NUEVOS CAMPOS DE KEYWORDS
  kw_anadir: string | null;
  kw_eliminar: string | null;
}

interface FetchClientesParams {
  page?: number;
  limit?: number;
  search?: string;
  f_alta_inicio?: string;
  f_alta_fin?: string;
  f_baja_inicio?: string;
  f_baja_fin?: string;
  ordenarPor?: string;
}

export const fetchClientes = async (params: FetchClientesParams) => {
  const token = getAuthToken();

  if (!token) {
    window.location.href = '/login';
    throw new Error('Token no encontrado. El usuario no está autenticado.');
  }

  const queryString = new URLSearchParams();

  if (params.page) queryString.append('page', params.page.toString());
  if (params.limit) queryString.append('limit', params.limit.toString());
  if (params.search) queryString.append('search', params.search);
  if (params.f_alta_inicio) queryString.append('f_alta_inicio', params.f_alta_inicio);
  if (params.f_alta_fin) queryString.append('f_alta_fin', params.f_alta_fin);
  if (params.f_baja_inicio) queryString.append('f_baja_inicio', params.f_baja_inicio);
  if (params.f_baja_fin) queryString.append('f_baja_fin', params.f_baja_fin);
  if (params.ordenarPor) queryString.append('ordenarPor', params.ordenarPor);

  const response = await fetch(`${API_URL}/clientes?${queryString.toString()}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    if (response.status === 403 || response.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = '/login';
      throw new Error('Token expirado o inválido');
    }
    const errorText = await response.text();
    throw new Error(`Error al obtener los clientes: ${errorText}`);
  }

  const data = await response.json();
  return data; // { data, total, page, limit }
};

export const fetchClienteById = async (id_usuario: string): Promise<Cliente> => {
  const token = getAuthToken();

  if (!token) {
    window.location.href = '/login';
    throw new Error('Token no encontrado. El usuario no está autenticado.');
  }

  const response = await fetch(`${API_URL}/clientes/${id_usuario}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Error al obtener los datos del cliente');
  }

  return response.json();
};

export const updateCliente = async (id_usuario: string, updates: Partial<Cliente>) => {
  const token = getAuthToken();

  if (!token) {
    window.location.href = '/login';
    throw new Error('Token no encontrado. El usuario no está autenticado.');
  }

  const response = await fetch(`${API_URL}/clientes/${id_usuario}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error('Error al actualizar el cliente');
  }

  return response.json();
};
